module.exports = __webpack_public_path__ + "interactiveApp/KurzByk/media/21a picanha-s-tukovym-krytim.jpg";